import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errText } from "@/lib/api";

export function ForcePasswordChange() {
  const { user, changePassword, logout } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try { await changePassword(f.current, f.next); toast.success("Password updated — welcome aboard"); } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0e11] p-6">
      <form onSubmit={submit} className="w-full max-w-sm fade-in" data-testid="force-password-form">
        <div className="flex items-center gap-2"><KeyRound size={16} className="text-[#fcd535]" /><h2 className="text-lg font-semibold text-white">Set a new password</h2></div>
        <p className="text-xs text-[#848e9c] mt-1">{user?.email} — your account uses a temporary password. Choose a new one (min 10 characters) to continue.</p>
        <input type="password" placeholder="Temporary password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} className="input mt-6" required autoComplete="current-password" data-testid="force-password-current" />
        <input type="password" placeholder="New password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} className="input mt-2" required minLength={10} autoComplete="new-password" data-testid="force-password-new" />
        <input type="password" placeholder="Confirm new password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="input mt-2" required autoComplete="new-password" data-testid="force-password-confirm" />
        <button type="submit" disabled={busy} className="btn-yellow w-full rounded h-10 mt-6 text-sm" data-testid="force-password-submit">{busy ? "Saving…" : "Save and continue"}</button>
        <button type="button" onClick={logout} className="w-full mt-3 text-[11px] text-[#5e6673] hover:text-white" data-testid="force-password-logout">Sign out</button>
      </form>
    </div>
  );
}
